import React from "react"

import Printer from "pages/printer"
import Settings from "pages/settings"
import KioskCheckout from "pages/kiosk-checkout"
import KioskFood from "pages/kiosk-food"
import KioskLanguages from "pages/kiosk-languages"
import KioskPayment from "pages/kiosk-payment"
import KioskFoods from "pages/kiosk-foods"
import KioskDeliveryTypes from "pages/kiosk-delivery-types"
import ShiftCashierHistory from "pages/shift-cashier-history"
import KioskCinemaSolons from "pages/kiosk-cinema-solons"

const privateRoutes = [
  {
    path: "/kiosk-checkout",
    component: <KioskCheckout />
  },
  {
    path: "/kiosk-foods",
    component: <KioskFoods />
  },

  {
    path: "/kiosk-food/:_id",
    component: <KioskFood />
  },

  {
    path: "/kiosk-languages",
    component: <KioskLanguages />
  },
  {
    path: "/kiosk-payment",
    component: <KioskPayment />
  },
  {
    path: "/kiosk-delivery-types",
    component: <KioskDeliveryTypes />
  },
  {
    path: "/kiosk-cinema-solons",
    component: <KioskCinemaSolons />
  },
  {
    path: "/kiosk-settings",
    component: <Settings />
  },
  {
    path: "/kiosk-printer",
    component: <Printer />
  },
  {
    path: "/kiosk-shift-cashier-history",
    component: <ShiftCashierHistory />
  }
]

export default privateRoutes